import { userConstants } from '../constants/user.constants.js';
import { SET_TITLE_ID } from "../constants";


let brandId = JSON.parse(localStorage.getItem('_brandId'));
let brand = JSON.parse(localStorage.getItem('_brand'));
const initialState = brandId && brand ? {
  brandId: parseInt(brandId, 10),
  brand: brand,
  coins: 0,
  titleId: '',
  brandConstants: {},
} : {};

export const global = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.LOY3_GET_BRAND_ID_SUCCESS:
      return {
        ...state,
        brandId: action.brandId,
      };
    case userConstants.LOY3_GET_BRAND_SUCCESS:
      return {
        ...state,
        brand: action.brand
      };
    case SET_TITLE_ID:
      return {
        ...state,
        titleId: action.titleId
      };
    case userConstants.LOY3_SET_BRAND_CONSTANTS:
      return {
        ...state,
        brandConstants: action.constants,
      };
    default:
      return state
  }
};
